<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';

    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    import Swal from 'sweetalert2'
    import { Splide, SplideSlide } from '@splidejs/svelte-splide';
    import '@splidejs/splide/dist/css/themes/splide-default.min.css';
    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    export let params = {};
    let sid = ""
    let gid = ""
    let providerName = ""
    let gameList
    let gametypeList = []
    let loading = true
    let sectiongame = false
    let device = 'desktop'
    let tabs= '';
    async function getProvider() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getgamelist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:gid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(json.payload.provider.isList==1){
                if(json.payload.gamelist.length == 1){
                    loading = false
                    push('/startgame/'+json.payload.gamelist[0]._id)
                }else{                    
                    gameList = json.payload.gamelist
                    providerName = json.payload.provider.providerName
                    sid = json.payload.provider.platform
                    tabs = json.payload.provider.tab
                    getPlatform()
                    loading = false
                }
                
                
            }else{
                // window.location = json.payload.url
                getGameURL(json.payload.provider._id)
            }
            
		} else {
            gameList = []
            throw new Error(json);
		}
    }
    async function getGameURL(mgds) {
        Swal.fire({
            title: 'กรุณารอสักครู่',
            html: 'เรากำลังพาคุณเข้าสู่เกม ขอให้โชคดี Good Luck.',
            timer: 10000,
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
            willClose: () => {
                
            }
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
                
            }
        })
        loading = true
        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:mgds,
                device:device,
                type:"provider"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // window.location = json.payload
            // loading = false
            transferCash(json.txid,json.payload)
		} else {
            loading = false
            if(json.statusCode==205){
                Swal.fire({
                    title: "ไม่สามารถเล่นเกมได้",
                    text: json.message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ยกเลิกโปรโมชั่น",
                    cancelButtonText: "ปิด"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        clearpromotion()
                    }
                });
            }else{
                Swal.fire(json.message)
            }
            // gameList = []
            throw new Error(json);
		}
        
    }
    async function clearpromotion() {
        // loaDing =false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/clearpromotion", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire(json.message)
            push('/dashboard')
		} else {
            Swal.fire(json.message)
            push('/dashboard')
            throw new Error(json);
		}
    }
    async function transferCash(txid,url) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/transfercash", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                txid:txid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            window.location = url
		} else {

            throw new Error(json);
		}
    }
    async function getPlatform() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatform", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({prefix:sid})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            gametypeList = json.payload
        } else {

            throw new Error(json);
        }
    }
    let platformList = []
    let platformDF = []
    let prefixDF = '';
    let ufabetset = false;
    let ufabetid = '';
    async function getPlatformDF() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatformlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            platformList = json.payload
             let dataPL = []
            if(dataSetting.platform){
                dataPL = JSON.parse(dataSetting.platform)
            }
            for await (let abs of platformList) {
                if(dataPL.length>0){
                    var xx= 0;
                    for await (let val2 of dataPL) {
                        if(abs._id==val2){
                            xx=xx+1
                            break;
                        }
                    }
                    if(xx>0){
                        if(abs.platform_prefix!='UFA'){prefixDF=abs.platform_prefix}
                        if(abs.platform_prefix=='UFA'){
                            ufabetset = true
                        }
                    }
                }else{
                        if(abs.platform_prefix!='UFA'){prefixDF=abs.platform_prefix}
                        if(abs.platform_prefix=='UFA'){
                            ufabetset = true
                        }
                }
            }
		} else {

            throw new Error(json);
		}
    }
    let isLoad = true
    async function setHeader(types) {
        providerName = 'UFABET'
        isLoad = false
        
    }
    
    let names = '';
    let promise
    $: {

        if (params && params.gid) {
            gid = params.gid
            promise = getProvider()
            getPlatformDF()
            
        } 
    }
  
</script>
<div class="default-home">
<div class="row mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
  <div class="themes-home-default lists" style="margin-left:0px;margin-right:0px;padding:0px;margin-bottom: 5px;">
    <div class="justify-content-center mb-1" style="margin: 0px !important;width: 100%;padding:0px !important;">
            <div class="row blog-home-games providers">
            {#each gametypeList as prs}
            <div class="col-3" style="padding-bottom: 0px !important;" >
                <button type="button" class="btn-games" on:click={() => push('/provider/'+sid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="Slot AMB123" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">
                            {#if prs=='LIVECASINO' || prs=='casino'}{names='คาสิโน'}
                            {:else if prs=='SPORT' || prs=='sport'}{names='กีฬา'}
                            {:else if prs=='EGAMES' || prs=='game'}{names='สล็อต'}
                            {:else if prs=='POKER' || prs=='card'}{names='เกมไพ่'}
                            {:else if prs=='lotto'}{names='หวย'}
                            {:else if prs=='fish'}{names='ยิงปลา'}
                            {:else if prs=='TRADING' || prs=='other'}{names='อื่นๆ'}
                            {/if}
                        </div>
                    </div>
                </button> 
            </div>
            {/each}
            {#if ufabetset}
            <div class="col-3"  style="padding-bottom: 0px !important;">
                <button type="button" class="btn-games" on:click={() => setHeader('UFA')}>
                    <img decoding="async" src="./assets/icon/ufa-icon.png" alt="UFABET" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile"><span style="color: gold;">UFA</span>BET</div>
                    </div>
                </button>
            </div>
            {/if}
        </div>
        
    </div>
    </div>
    <div class="col-12 text-center mt-0 mb-1">
        <h6 class="header-n">{providerName}</h6>
    </div>
    {#if loading}
    <div class="col-12 text-center mt-2" style="min-height: 500px;">
        <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
    </div>
    {/if}
    {#if !loading}
    <div class="col-12 pb-5" style="min-height: 500px;">
        {#if isLoad}
        <div class="row d-flex justify-content-center ">
            {#await promise}
            
            {:then number}
            {#if gameList.length>0}
            {#each gameList as prs}
            <div class="col-4 text-center mb-1 pointer" >
                <a href="#/startgame/{prs._id}" target="_blank"  style="text-decoration: none !important;">
                <img src="{prs.image}" class="img-fluid" style="border-radius: 10px;">
                
                <span class="text-white text-sm" style="text-decoration: none !important;">{prs.gameName}</span>
                </a>
            </div>
            {/each}
            {:else}
            <div class="col-12 ">
                <div class="blog-coming" style="text-align: center;">
                    <b>Coming soon.</b>
                </div>
            </div>
            {/if}
            {/await}
        </div>
        {:else}
        <div class="row d-flex justify-content-center">
            <div class="col-sm-4 col-12"></div>
            <div class="col-12 col-sm-4 text-center mb-1 pointer" style="position:relative;">
                <a href="javascript:;"  on:click={() => getGameURL('UFA')}  style="text-decoration: none;">
                    <img src="./assets/webgame/UFABET/ufabet.png" class="img-fluid" alt="UFABET" style="border-radius: 10px;margin-bottom: 5px;"><br />
                    <span class="text-white text-sm mt-2"><b>UFABET</b></span>
                </a>
            </div>
            <div class="col-sm-4 col-12"></div>
        </div>
        {/if}
    </div>
    {/if}
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3">
        <HeaderThemes/>
        <div class="col-12 text-center blog-providers mt-5 {sid}">
            <div class="row divs p-0 ">
                {#if !loading}
                {#each gametypeList as prs}
                {#if tabs==prs}
                <button type="button" class="btn-games active" on:click={() => push('/provider/'+sid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="{prs} AMB" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {:else}
                <div class="col">
                    <button type="button" class="btn-games" on:click={() => push('/provider/'+sid+'/'+prs)}>
                        <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="Slot AMB123" class="img-fluid -ic-menu entered lazyloaded">
                        <div class="-text-provider-wrapper">
                            <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                        </div>
                    </button> 
                </div>
                {/if}
                {/each}
                {/if}
            </div>
        </div>
        <div class="col-12 text-center mt-0 mb-1 blog-providers">
            <h6  class="head-title">{providerName}</h6>
        </div>
        {#if loading}
        <div class="col-12 text-center mt-2" style="min-height: 500px;">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="col-12 pb-5" style="min-height: 500px;">
            <div class="row d-flex justify-content-center ">
                {#await promise}
                
                {:then number}
                {#each gameList as prs}
                <div class="col-4 text-center mb-1 pointer" >
                    <a href="#/startgame/{prs._id}" target="_blank" style="text-decoration: none !important;">
                    <img src="{prs.image}" class="img-fluid" style="border-radius: 10px;">
                    
                    <span class="text-white text-sm" style="text-decoration: none !important;">{prs.gameName}</span>
                    </a>
                </div>
                {/each}
                {/await}
            </div>
        </div>
        {/if}
    </div>
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
   @media only screen and (max-width: 767px) {
        .default-home{
            margin-bottom: 5rem !important;
        }
        :global(.themes-home-default .-text-nav-menu.-title-mobile){
            font-size: 16px;
            position: relative;
            top: -4px;
        }
        :global(.themes-home-default .row){
            margin-left: 0px !important;
            margin-right: 0px !important;
        }
        .themes-home-default.lists{
            width: 100% !important;
        }
    }
    :global(.splide){
        width: 354px !important;
        padding: 0px !important;
        margin: 0px !important;
    }
    :global(.splide__pagination){
        display: none !important;
    }
    :global(.splide .splide__arrow.splide__arrow--prev){
        position: absolute;
        left: -10px;
        top: 32px;
        width: 15px;
        height: 15px;
        font-size: 0.5rem;
    }
    :global(.splide .splide__arrow.splide__arrow--next){
        position: absolute;
        right: -10px;
        top: 32px;
        width: 15px;
        height: 15px;
        font-size: 0.5rem;
    }
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.8rem;
    }
    .pointer{
        cursor: pointer;
    }
    .btn-games {
        margin: 0;
        padding: 7px 10px;
        background: linear-gradient(155deg, #424242, #101010);
        position: relative;
        box-shadow: 0 5px 10px #000000b0;
        border-radius: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all .3s;
        font-size: 16px;
        position: relative;
        color: #FFF;
        width: 75px !important;
        border: 0px;
    }
    .row.divs .col {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .btn-games img {
        max-width: 35px !important;
    }
    .btn-games .-title-mobile {
        font-size: 10px;
    }
    .text-white.text-sm{
        font-size: 10px;
    }
    .btn-games.active, .btn-games:hover {
        background: linear-gradient(181deg,#ffd34e,#794909);
    }
    @media only screen and (max-width: 767px) {
        :global(.themes-home-default .-text-nav-menu.-title-mobile){
            font-size: 16px !important;
            position: relative;
            top: -4px;
        }
    }
    @media only screen and (max-width: 400px) {
        .themes-home-default .-text-nav-menu.-title-mobile{
            font-size: 14px !important;
        }
    }
</style>